import config from '@/config'
import api from '@/modules/api'
import { GetParameterValues } from '@/modules/helper/index'
import moment from 'moment'
export default {
  state: {
    IsPaymentDone: null,
    Packages: [],
    SubscriptionPackages: [],
    ServicesPackages: [],
    SelectedPackage: '',
    selectedPackageId: '',
    clientData: '',
    countries: [],
    PaymentMethod: '',
    ImagePath: '',
    CartPackage: [],
    IsDirectCallComp: false,
    SelectedSubscriptionId: null,
    AppName: '',
    ServiceType: 1,
    CountryCode: '',
    StripePublishableKey: config.stripe_key,
    HeaderText: '',
    IsOffer: false,
    showOfferText: '',
    SpecialOfferPromotionTitle: '',
    DisableBasicAppSuscription: '',
    DisableSmartAppSuscription: '',
    DisableProAppSuscription: '',
    CurrentSubscriptionLevelId: '',
    AppSubscription: '',
    PaymentTransactionId: '',
    VatId: '',
    PurchaseSubscriptionLevelId: '',
    IsalreadyPlusPkgServiceType2: false,
    IsCounterPeriodOffer: false,
    PackageProductPrice: [],
    PackageOfferPrice: [],
    PlusPackageproduct: [],
    NewProductBillingData: [],
    NewProductPublishingData: [],
    DisableBasicPlanReason: false,
    DisableSmartPlanReason: false,
    DisableBuyProPlanReason: false
  },
  getters: {
    StripePublishableKey: state => state.StripePublishableKey,
    IsPaymentDone: state => sessionStorage.getItem('IsPaymentDone') === undefined ? null : sessionStorage.getItem('IsPaymentDone'),
    ServiceType: state => state.ServiceType,
    Packages: state => state.Packages,
    ServicesPackages: state => state.ServicesPackages,
    SubscriptionPackages: state => state.SubscriptionPackages,
    countries: state => state.countries,
    SelectedPackage: state => state.SelectedPackage,
    PaymentMethod: state => state.PaymentMethod,
    CartPackage: state => state.CartPackage,
    AppName: state => state.AppName,
    SelectedSubscriptionId: state => state.SelectedSubscriptionId,
    HeaderText: state => state.HeaderText,
    IsOffer: state => state.IsOffer,
    showOfferText: state => state.showOfferText,
    SpecialOfferPromotionTitle: state => state.SpecialOfferPromotionTitle,
    DisableBasicAppSuscription: state => state.DisableBasicAppSuscription,
    DisableSmartAppSuscription: state => state.DisableSmartAppSuscription,
    DisableProAppSuscription: state => state.DisableProAppSuscription,
    CurrentSubscriptionLevelId: state => state.CurrentSubscriptionLevelId,
    AppSubscription: state => state.AppSubscription,
    VatId: state => state.VatId,
    PurchaseSubscriptionLevelId: state => state.PurchaseSubscriptionLevelId,
    PaymentTransactionId: state => state.PaymentTransactionId,
    IsalreadyPlusPkgServiceType2: state => state.IsalreadyPlusPkgServiceType2,
    IsCounterPeriodOffer: state => state.IsCounterPeriodOffer,
    PackageOfferPrice: state => state.PackageOfferPrice,
    PackageProductPrice: state => state.PackageProductPrice,
    PlusPackageproduct: state => state.PlusPackageproduct,
    NewProductBillingData: state => state.NewProductBillingData,
    NewProductPublishingData: state => state.NewProductPublishingData,
    DisableBasicPlanReason: state => state.DisableBasicPlanReason,
    DisableSmartPlanReason: state => state.DisableSmartPlanReason,
    DisableBuyProPlanReason: state => state.DisableBuyProPlanReason,
    Currency: state => {
      const country = state.countries.find(country => country.DefaultCurrency === state.Currency)
      if (country) {
        return country.CurrencySymbol
      } else { return '' }
    },
    IsDoller: state => {
      const country = state.countries.find(country => country.DefaultCurrency === state.Currency)
      if (country) {
        return country.CurrencySymbol.trim() === '$'
      } else { return false }
    }
  },
  mutations: {
    setPlusPackageproduct (state, payload) { state.PlusPackageproduct = payload },
    setPackageOfferPrice (state, payload) { state.PackageOfferPrice = payload },
    setPackageProductPrice (state, payload) { state.PackageProductPrice = payload },
    setCurrency (state, payload) { state.Currency = payload },
    setCountryCode (state, payload) { state.CountryCode = payload },
    setServiceType (state, type) { state.ServiceType = type },
    setHeaderText (state, HeaderText) { state.HeaderText = HeaderText },
    setNewProductBillingData (state, payload) { state.NewProductBillingData = payload },
    setNewProductPublishingData (state, payload) { state.NewProductPublishingData = payload },
    setDisableBasicPlanReason (state, value) { state.DisableBasicPlanReason = value },
    setDisableSmartPlanReason (state, value) { state.DisableSmartPlanReason = value },
    setDisableBuyProPlanReason (state, value) { state.DisableBuyProPlanReason = value },
    PackageAddToCart (state, payload) {
      state.CartPackage = []
      payload.forEach(item => { state.CartPackage.push(item) })
    },
    UpdateSelectedPackage (state, payload) {
      state.SelectedPackage = payload.selectedSubscription
      state.selectedPackageId = payload.subscriptionId
    },
    SetDirectCallComp (state, payload) { state.IsDirectCallComp = payload },
    updatePaymentMethod (state, payload) {
      state.PaymentMethod = {
        PaymentType: payload.PaymentType,
        ImageName: payload.ImageName
      }
    },
    UpdateSubscriptionId (state, payload) { state.SelectedSubscriptionId = parseInt(payload) },
    UpdateAppName (state, payload) { state.AppName = payload },
    SetVatId (state, payload) { state.VatId = payload },
    setPurchaseSubscriptionLevelId (state, payload) { state.PurchaseSubscriptionLevelId = payload },
    SetPaymentTransactionId (state, payload) { state.PaymentTransactionId = payload },
    UpdateAppSubscription (state, payload) { state.AppSubscription = payload }
  },
  actions: {
    populateOrderData: async ({ commit, dispatch, rootGetters, state }, payload) => {
      commit('updatePaymentMethod', { PaymentType: '', ImageName: '' })
      if (rootGetters.subscription) {
        commit('UpdateAppSubscription', rootGetters.subscription)
      } else {
        if (payload.Subscription_Id) {
          const subscriptionResponse = await api.Order.getSubscriptionData(payload.Subscription_Id)
          commit('UpdateAppSubscription', subscriptionResponse[0])
        }
      }
      if (!payload.clientId) {
        payload.clientId = rootGetters.AppSubscription.Client_Id
      } else {
        let user = await api.user.getClientInfo(payload.clientId)
        rootGetters.user.Id = user[0].Id
        rootGetters.user.City = user[0].City
        rootGetters.user.Address = user[0].Address
        rootGetters.user.ClientAuthId = user[0].ClientAuthId
        rootGetters.user.CompanyName = user[0].CompanyName
        rootGetters.user.ContactFirstname = user[0].ContactFirstname
        rootGetters.user.ContactLastname = user[0].ContactLastname
        rootGetters.user.Country = user[0].Country
        rootGetters.user.Currency = user[0].Currency
        rootGetters.user.Email = user[0].Email
        rootGetters.user.Username = user[0].Username
        rootGetters.user.PostalCode = user[0].PostalCode
        payload.Language = user[0].Language
        commit('setCountryCode', user[0].Country)
        commit('setCurrency', user[0].Currency)
      }
      if (rootGetters.user.Authenticated !== true || payload.UserName !== null) {
        let SubscriptionAppInfo = {
          Client_Id: payload.clientId,
          Email: payload.UserName,
          ServiceType: parseInt(payload.ServiceType)
        }
        if (payload.Subscription_Id) {
          state.SelectedSubscriptionId = payload.Subscription_Id
        } else {
          const OrderProcessApps = await api.Order.GetOrderProcessApps(SubscriptionAppInfo)
          rootGetters.user.OrderProcessApps = OrderProcessApps
        }
        await dispatch('populateOrderServiceData', payload)
      } else {
        payload.Language = rootGetters.user.Language
        commit('setCountryCode', rootGetters.user.Country)
        commit('setCurrency', rootGetters.user.Currency)
        if (payload.Subscription_Id) {
          state.SelectedSubscriptionId = payload.Subscription_Id
        }
        await dispatch('populateOrderServiceData', payload)
      }
    },
    populateOrderServiceData: async ({state, commit, dispatch, rootGetters}, payload) => {
      state.IsalreadyPlusPkgServiceType2 = false
      let currentTimeStamp = moment().unix()
      let offerResponse = ''
      let productResponse = ''
      productResponse = await api.Order.getBillingProducts(payload.clientId)
      offerResponse = await api.Order.getSubscriptionOffer(currentTimeStamp, payload.clientId)
      let SubscriptionsPurchasedProductsResponse = ''
      if (payload.Subscription_Id) {
        SubscriptionsPurchasedProductsResponse = await api.Order.getSubscriptionsPurchasedProductsData(payload.Subscription_Id)
      }
      const subscriptionLevelResponse = await api.Order.getSubscriptionLevels()
      const countriesResponse = await api.system.getCountriesInfo(localStorage.getItem('language'))
      let offer = offerResponse.length > 0 ? offerResponse.find(product => product.Id === -1000) : null
      let SystemTableBillingSpecialOffersPricingResponse = []
      if (rootGetters.userOfferDetails.IsOfferPeriod && offer != null) {
        state.IsCounterPeriodOffer = true
        SystemTableBillingSpecialOffersPricingResponse = await api.Order.getSystemTableBillingSpecialOffersPricing(-1000, payload.Language, rootGetters.user.Currency)
      } else {
        let offer = offerResponse.length > 0 ? offerResponse.find(product => product.Id > 0) : null
        SystemTableBillingSpecialOffersPricingResponse = offerResponse[0] ? await api.Order.getSystemTableBillingSpecialOffersPricing(offer ? offer.Id : 0, payload.Language, rootGetters.user.Currency) : []
      }
      let servicesPackages = {
        PlusPackage: {},
        BasiAppPlusPackage: {},
        SmartAppPlusPackage: {},
        ProAppPlusPackage: {},
        UpgradeBasictoSmart: {},
        UpgradeBasictoSmartBundlePlus: {},
        UpgradeBasictoPro: {},
        UpgradeBasictoProBundlePlus: {},
        UpgradeSmarttoPro: {},
        UpgradeSmarttoProBundlePlus: {},
        DesigneService: {},
        PublishingServiceCommon: {},
        PublishingServiceiOS: {},
        PublishingServiceAndroid: {},
        SingleAppUpdate: {},
        SinglePushNotification: {}
      }
      let subscriptionPackages = {
        FreeApp: {},
        SmartApp: {},
        ProApp: {}
      }
      const ModuleinternalInfo = payload.Subscription_Id ? await api.Order.GetModuleinternalInfo(payload.Subscription_Id) : ''
      await Promise.all([productResponse, subscriptionLevelResponse, offerResponse, countriesResponse, SubscriptionsPurchasedProductsResponse, SystemTableBillingSpecialOffersPricingResponse, ModuleinternalInfo]).then(async values => {
        if (values[2].length > 0) {
          state.SpecialOfferPromotionTitle = values[2].SpecialOfferPromotionTitle
        }
        state.PlusPackageproduct = values[4]
        state.PackageProductPrice = values[0]
        if (countriesResponse != null) {
          state.countries = values[3]
        }
        let PurchasedSubscriptionLevelId = rootGetters.AppSubscription.PurchasedSubscriptionLevel_Id
        commit('setPurchaseSubscriptionLevelId', PurchasedSubscriptionLevelId)
        let Subscriptionlavels = values[1].filter(val => val.Id === PurchasedSubscriptionLevelId)[0]
        if (state.ServiceType === 1) {
          if (PurchasedSubscriptionLevelId === null) {
            state.DisableBasicAppSuscription = ''
            state.DisableSmartAppSuscription = ''
            if (rootGetters.AppSubscription.SubscriptionLevel_Id === 2) {
              state.DisableBasicAppSuscription = 'disable'
            }
            if (rootGetters.AppSubscription.SubscriptionLevel_Id === 3) {
              state.DisableBasicAppSuscription = 'disable'
              state.DisableSmartAppSuscription = 'disable'
            }
            values[1].forEach(value => {
              let data = dispatch('processservicedata', {'subId': value.Subscription_Product_Id, 'subOfferId': value.Subscription_Product_Id, 'plusId': value.SubscriptionBundle_Product_Id, 'plusOfferId': value.SubscriptionBundle_Product_Id, 'name': value.Name})
              Promise.all([data]).then(values => {
                if (value.Id === 1) {
                  subscriptionPackages.FreeApp = values[0].subscription
                  servicesPackages.BasiAppPlusPackage = values[0].PlusPackage
                } else if (value.Id === 2) {
                  subscriptionPackages.SmartApp = values[0].subscription
                  servicesPackages.SmartAppPlusPackage = values[0].PlusPackage
                } else if (value.Id === 3) {
                  subscriptionPackages.ProApp = values[0].subscription
                  servicesPackages.ProAppPlusPackage = values[0].PlusPackage
                }
              })
            })
          }
          if (PurchasedSubscriptionLevelId === 1) {
            state.DisableBasicAppSuscription = 'hideSubscription'
            rootGetters.resource.str_Subscription_headertext = rootGetters.resource.str_upgradeappheadertitle
            let IsalreadyPlusPkg = values[4].filter(val => val.Product_Id === 100011 || val.Product_Id === 100101)[0]
            if (IsalreadyPlusPkg) {
              state.IsalreadyPlusPkgServiceType2 = true
              let data = dispatch('processservicedata', {'subId': Subscriptionlavels.UpgradeSMARTBundle_Product_Id, 'subOfferId': Subscriptionlavels.UpgradeSMARTBundle_Product_Id, 'plusId': Subscriptionlavels.UpgradePROBundle_Product_Id, 'plusOfferId': Subscriptionlavels.UpgradePROBundle_Product_Id})
              Promise.all([data]).then(values => {
                subscriptionPackages.SmartApp = values[0].subscription
                subscriptionPackages.ProApp = values[0].PlusPackage
              })
            } else {
              servicesPackages.UpgradeBasictoProBundlePlus = values[0].filter(val => val.Id === Subscriptionlavels.UpgradePROBundle_Product_Id)[0]
              let data = dispatch('processservicedata', {'subId': Subscriptionlavels.UpgradeSMART_Product_Id, 'subOfferId': Subscriptionlavels.UpgradeSMART_Product_Id, 'plusId': Subscriptionlavels.UpgradeSMARTBundle_Product_Id, 'plusOfferId': Subscriptionlavels.UpgradeSMART_Product_Id, 'name': 'SMART APP'})
              Promise.all([data]).then(values => {
                servicesPackages.UpgradeBasictoSmart = values[0].subscription
                servicesPackages.UpgradeBasictoSmartBundlePlus = values[0].PlusPackage
                subscriptionPackages.SmartApp = values[0].subscription
                servicesPackages.SmartAppPlusPackage = values[0].PlusPackage
              })
              data = dispatch('processservicedata', {'subId': Subscriptionlavels.UpgradePRO_Product_Id, 'subOfferId': Subscriptionlavels.UpgradePRO_Product_Id, 'plusId': Subscriptionlavels.UpgradePROBundle_Product_Id, 'plusOfferId': Subscriptionlavels.UpgradePROBundle_Product_Id, 'name': 'PRO APP'})
              Promise.all([data]).then(values => {
                servicesPackages.UpgradeBasictoPro = values[0].subscription
                servicesPackages.UpgradeBasictoProBundlePlus = values[0].PlusPackage
                subscriptionPackages.ProApp = values[0].subscription
                servicesPackages.ProAppPlusPackage = values[0].PlusPackage
              })
              api.system.activityLog({ LogMessage_Id: 1000701, Subscription_Id: payload.Subscription_Id, Client_Id: rootGetters.IsAuthenticated ? rootGetters.user.Id : null })
            }
          }
          if (PurchasedSubscriptionLevelId === 2) {
            rootGetters.resource.str_Subscription_headertext = rootGetters.resource.str_upgradeappheadertitle
            state.DisableBasicAppSuscription = 'hideSubscription'
            state.DisableSmartAppSuscription = 'hideSubscription'
            let IsalreadyPlusPkg = values[4].filter(val => val.Product_Id === 100012 || val.Product_Id === 100102)[0]
            if (IsalreadyPlusPkg) {
              state.IsalreadyPlusPkgServiceType2 = true
              let data = dispatch('processservicedata', {'subId': 100206, 'subOfferId': 100206, 'mode': 1})
              Promise.all([data]).then(values => { subscriptionPackages.ProApp = values[0].subscription })
            } else {
              let data = dispatch('processservicedata', {'subId': Subscriptionlavels.UpgradePRO_Product_Id, 'subOfferId': Subscriptionlavels.UpgradePRO_Product_Id, 'plusId': Subscriptionlavels.UpgradePROBundle_Product_Id, 'plusOfferId': Subscriptionlavels.UpgradePROBundle_Product_Id, 'name': 'PRO APP'})
              Promise.all([data]).then(values => {
                servicesPackages.UpgradeSmarttoPro = values[0].subscription
                servicesPackages.UpgradeSmarttoProBundlePlus = values[0].PlusPackage
                servicesPackages.UpgradeBasictoProBundlePlus = values[0].PlusPackage
                subscriptionPackages.ProApp = values[0].subscription
                servicesPackages.ProAppPlusPackage = values[0].PlusPackage
              })
              api.system.activityLog({LogMessage_Id: 1000701,
                Subscription_Id: payload.Subscription_Id,
                Client_Id: rootGetters.IsAuthenticated ? rootGetters.user.Id : null
              })
            }
          }
          if (PurchasedSubscriptionLevelId === 3) {
            dispatch('setUpgradenotpossiblemessage')
          }
        }
        if (state.ServiceType === 2) {
          if (PurchasedSubscriptionLevelId === null) {
            let urldata = decodeURIComponent(window.location.href)
            let url = urldata.split('/2/')
            let newurl = url[0] + '/1/' + url[1]
            location.href = newurl
          }
          let PurchasedSubscriptionLevelPlusPackageId = PurchasedSubscriptionLevelId === 1 ? 100101 : PurchasedSubscriptionLevelId === 2 ? 100102 : 100103
          let PurchasedSubscriptionLevelPlusPackageProductId = PurchasedSubscriptionLevelId === 1 ? 100011 : PurchasedSubscriptionLevelId === 2 ? 100012 : 100013
          let IsalreadyPlusPkg = values[4].filter(val => val.Product_Id === PurchasedSubscriptionLevelPlusPackageProductId || val.Product_Id === PurchasedSubscriptionLevelPlusPackageId)[0]
          let data = dispatch('processservicedata', {'subId': PurchasedSubscriptionLevelPlusPackageId, 'subOfferId': PurchasedSubscriptionLevelPlusPackageId, 'mode': 1})
          Promise.all([data]).then(values => { servicesPackages.PlusPackage = values[0].subscription })
          if (IsalreadyPlusPkg) {
            dispatch('setUpgradenotpossiblemessage')
            state.IsalreadyPlusPkgServiceType2 = true
          }
        }
        state.CurrentSubscriptionLevelId = PurchasedSubscriptionLevelId
        if (state.ServiceType === 3) {
          let data = dispatch('processservicedata', {'subId': 101001, 'subOfferId': 101001, 'mode': 1})
          Promise.all([data]).then(values => { servicesPackages.DesigneService = values[0].subscription })
        }
        if (state.ServiceType === 4) {
          let data = dispatch('processservicedata', {'subId': 101003, 'subOfferId': 101003, 'mode': 1})
          Promise.all([data]).then(values => { servicesPackages.PublishingServiceAndroid = values[0].subscription })
          data = dispatch('processservicedata', {'subId': 101002, 'subOfferId': 101002, 'mode': 1})
          Promise.all([data]).then(values => { servicesPackages.PublishingServiceiOS = values[0].subscription })
          data = dispatch('processservicedata', {'subId': 101004, 'subOfferId': 101004, 'mode': 1})
          Promise.all([data]).then(values => { servicesPackages.PublishingServiceCommon = values[0].subscription })
        }
        if (state.ServiceType === 5 || state.ServiceType === 6) {
          let Id = PurchasedSubscriptionLevelId === null ? 100101 : PurchasedSubscriptionLevelId === 1 ? 100102 : 100103
          let AlreadyPlusPackage = dispatch('setAlreadyPlusPackage', {'Id': Id})
          let ServiceTypeId = state.ServiceType === 5 ? 101005 : 101006
          let data = dispatch('processservicedata', {'subId': ServiceTypeId, 'subOfferId': ServiceTypeId, 'mode': 1})
          Promise.all([AlreadyPlusPackage]).then(values => { servicesPackages.PlusPackage = values[0].subscription })
          Promise.all([data]).then(values => { state.ServiceType === 5 ? servicesPackages.SingleAppUpdate = values[0].subscription : servicesPackages.SinglePushNotification = values[0].subscription })
        }
        if (state.ServiceType === 1) {
          state.HeaderText = rootGetters.resource.str_Subscription_headertext
        } else if (state.ServiceType === 2) {
          state.HeaderText = rootGetters.resource.str_Plus_headertext
        } else if (state.ServiceType === 3) {
          state.HeaderText = rootGetters.resource.str_Design_headertext
        } else if (state.ServiceType === 4) {
          state.HeaderText = rootGetters.resource.str_Publish_headertext
        } else if (state.ServiceType === 5) {
          state.HeaderText = rootGetters.resource.str_SingleApp_headertext
        } else if (state.ServiceType === 6) {
          state.HeaderText = rootGetters.resource.str_SinglePushN_headertext
        }
      })
      state.SubscriptionPackages = subscriptionPackages
      state.ServicesPackages = servicesPackages
      state.Packages = subscriptionPackages
    },
    setAlreadyPlusPackage: async ({ state, dispatch }, payload) => {
      let IsalreadyPlusPkg = state.PlusPackageproduct.filter(val => val.Product_Id === payload.Id)[0]
      if (IsalreadyPlusPkg) {
        dispatch('setUpgradenotpossiblemessage')
        state.IsalreadyPlusPkgServiceType2 = true
      }
      let data = dispatch('processservicedata', {'subId': payload.Id, 'subOfferId': payload.Id, 'mode': 1})
      return data
    },
    setUpgradenotpossiblemessage: async ({ rootGetters }) => {
      rootGetters.resource.str_Subscription_headertext = rootGetters.resource.str_opheader2
      rootGetters.resource.str_Plus_headertext = rootGetters.resource.str_opheader2
      rootGetters.resource.str_OP_Error_Label1 = rootGetters.resource.str_no_upgradepossible
      rootGetters.resource.str_OP_Error_Label2 = rootGetters.resource.str_no_upgradepossibleplustext
      rootGetters.resource.str_OP_Error_Button1 = rootGetters.resource.str_Cockpit
    },
    processofferdata: async ({ state, commit }, payload) => {
      let subscription = {}
      subscription = state.PackageProductPrice.filter(val => val.Id === payload.subId)[0]
      let Specialofferdata = state.PackageOfferPrice.filter(val => val.Product_Id === payload.subOfferId)[0]
      subscription.SpecialPriceImage = Specialofferdata !== undefined ? Specialofferdata.SpecialPriceBanner : ''
      subscription.SpecialPrice = Specialofferdata !== undefined ? Specialofferdata.SpecialPrice : ''
      subscription.Isoffer = Specialofferdata !== undefined
      subscription.Name = payload.name
      return subscription
    },
    processservicedata: async ({ state, commit, dispatch }, payload) => {
      let packages = {}
      if (payload.mode === 1) {
        let data = dispatch('processofferdata', {'subId': payload.subId, 'subOfferId': payload.subOfferId})
        Promise.all([data]).then(values => { packages.subscription = values[0] })
      } else {
        let data = dispatch('processofferdata', {'subId': payload.subId, 'subOfferId': payload.subOfferId, name: payload.name})
        Promise.all([data]).then(values => { packages.subscription = values[0] })
        data = dispatch('processofferdata', {'subId': payload.plusId, 'subOfferId': payload.plusOfferId, name: payload.name})
        Promise.all([data]).then(values => { packages.PlusPackage = values[0] })
      }
      return packages
    },
    TrackOrderProcess: async ({ commit }, payload) => { await api.Order.trackOrderProcess(payload) },
    CheckVat: async ({ commit }, payload) => {
      let response = await api.Order.checkVatCode(payload)
      return response
    },
    StripeCharge: async ({ commit, state }, payload) => {
      let response = await api.Order.stripeCharge(payload)
      return response
    },
    updateHeaderText: ({commit}, payload) => { commit('setHeaderText', payload) },
    CreateCharge: async ({commit, dispatch, getters, rootGetters}, callback) => {
      let createcharge = GetParameterValues('createcharge')
      let clientsecret = GetParameterValues('client_secret')
      let username = rootGetters.user.Email
      let source1 = GetParameterValues('source')
      if (createcharge) {
        window.Stripe.setPublishableKey(getters.StripePublishableKey)
        window.Stripe.source.poll(source1, clientsecret, function (status, source) {
          if (source.status === 'chargeable') {
            let payload = {id: source.id, amount: source.amount, currency: source.currency, ReceiptEmail: username}
            dispatch('StripeCharge', payload).then(function (response) {
              if (response === 'succeeded') {
                sessionStorage.setItem('IsPaymentDone', true)
              }
            })
          } else if (source.status === 'consumed') {
            window.Stripe.source.cancelPoll(source1)
            callback({ // eslint-disable-line standard/no-callback-literal
              status: source.status
            })
          } else if (source.status === 'failed') {
            window.Stripe.source.cancelPoll(source1)
            callback({ // eslint-disable-line standard/no-callback-literal
              status: source.status
            })
          }
        })
      }
    },
    chargeBeePayment: async ({ commit, state }, payload) => {
      let response = await api.External.ChargeBeePayment(payload)
      return response
    },
    chargeBeePublishing: async ({ commit, state }, payload) => {
      let response = await api.External.chargeBeePublishing(payload)
      return response
    },
    chargeBeeUpgrade: async ({ commit, state }, payload) => {
      let response = await api.External.ChargeBeeUpgrade(payload)
      return response
    },
    populateNewOrderData: async ({ commit, dispatch, rootGetters, state }) => {
      let NewBillingProducts = await api.Order.getNewBillingProducts(rootGetters.user.Id)
      commit('setNewProductBillingData', NewBillingProducts)
    },
    populateNewPublishOrderData: async ({ commit, dispatch, rootGetters, state }) => {
      let NewBillingProducts = await api.Order.getNewPublishingProducts(rootGetters.user.Id)
      commit('setNewProductPublishingData', NewBillingProducts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/orderService.js